import React, { useEffect } from "react";
import './SideMenuBar.css';
import Tabs from "../Tabs/Tabs";
import Panel from "../Tabs/Panel";
import Men from "./Men";
import { X } from "phosphor-react";
import { setSideMenuBarOpen } from '../../appState/slices/auth/authSlice';
import { useSelector, useDispatch } from "react-redux";
import { getCategories, getCollections } from "../../appState/slices/categories/categorySlice";
import { Link } from "react-router-dom";
import { getCategoryDetails } from "../../appState/slices/product/productSlice";
import { ReactComponent as Logo } from '../../assets/logo/logo-name.svg';

const SideMenuBar = () => {
    const dispatch = useDispatch();
    const categories = useSelector((state) => state.category.categories);
    const collections = useSelector((state) => state.category.categories);
    const gender = useSelector((state) => state.auth.category.gender);
    useEffect(() => {
        dispatch(getCategories());
        dispatch(getCollections(gender));
    }, [gender])
    return (
        <div className={`sidebarcontainer`}>
            <nav className={`headercontainer2 nav-container`}>
                <div className="left-side">

                    <button onClick={() => dispatch(setSideMenuBarOpen(false))} >
                        <X size={20} className={`lightcolor `} />
                    </button>


                    {/* Apply dimensions and color to the parent Link */}
                    <Link
                        to="/"
                        className="lightcolor brand-name t0"
                    >
                        {/* Remove most classes from Logo, let it inherit */}
                        <Logo className="lightcolor logo-div" />
                    </Link>
                </div>
            </nav>
            <div className="sidebarscrollaber-container">
                <Tabs pagename="sidemenubar">
                    {[...categories].reverse().map((level1) => (
                        <Panel key={level1.gender} title={level1.gender}>
                            <Men
                                categories={level1.categories}
                                gender={level1.gender}
                            />
                        </Panel>
                    ))}
                </Tabs>
            </div>
        </div>

    );
}

export default SideMenuBar;

